export default {
  social_medias: []
}
